module.exports = __webpack_public_path__ + "images/category_lp/common/icon-babble-right@2x_e5e505854f08d4b02ec420681a82b046.png";